import React, { useEffect, useState } from "react";

const InstallButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Detect iPhone / iPad / iPod, including newer iPads
    const detectIOS = () => {
      const userAgent = window.navigator.userAgent;

      const isAppleMobile =
        /iPhone|iPad|iPod/i.test(userAgent);

      const isIPad =
        window.navigator.platform === "MacIntel" &&
        window.navigator.maxTouchPoints > 1;

      return isAppleMobile || isIPad;
    };

    setIsIOS(detectIOS());

    // Check whether app is already installed
    const mediaQuery = window.matchMedia(
      "(display-mode: standalone)"
    );

    const checkInstalled = () => {
      const installed =
        mediaQuery.matches ||
        window.navigator.standalone === true;

      setIsInstalled(installed);
    };

    // Android / supported browsers install prompt
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };

    const handleAppInstalled = () => {
      setIsInstalled(true);
      setDeferredPrompt(null);
    };

    checkInstalled();

    window.addEventListener(
      "beforeinstallprompt",
      handleBeforeInstallPrompt
    );

    window.addEventListener(
      "appinstalled",
      handleAppInstalled
    );

    mediaQuery.addEventListener?.(
      "change",
      checkInstalled
    );

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );

      window.removeEventListener(
        "appinstalled",
        handleAppInstalled
      );

      mediaQuery.removeEventListener?.(
        "change",
        checkInstalled
      );
    };
  }, []);

  const installApp = async () => {
    if (isInstalled) return;

    // iPhone / iPad installation instructions
    if (isIOS) {
      alert(
        "Install BFC Trade kwenye iPhone:\n\n" +
          "1. Fungua website kwenye Safari.\n" +
          "2. Bonyeza Share (alama ya mshale juu).\n" +
          "3. Chagua Add to Home Screen.\n" +
          "4. Bonyeza Add.\n\n" +
          "Kumbuka: Kama huoni chaguo hilo, hakikisha unatumia Safari."
      );

      return;
    }

    // Android / browsers with install prompt
    if (!deferredPrompt) {
      alert(
        "Install BFC Trade:\n\n" +
          "Fungua menu ya browser kisha chagua " +
          "Install App au Add to Home Screen."
      );

      return;
    }

    try {
      await deferredPrompt.prompt();

      const { outcome } =
        await deferredPrompt.userChoice;

      if (outcome === "accepted") {
        setIsInstalled(true);
      }
    } catch (error) {
      console.error("Installation failed:", error);
    } finally {
      setDeferredPrompt(null);
    }
  };

  // Hide button if app is already installed
  if (isInstalled) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={installApp}
      aria-label="Install BFC Trade"
      style={{
        position: "fixed",
        top: 70,
        right: 10,
        padding: "4px 0",
        margin: 0,
        background: "transparent",
        color: "#ffffff",
        border: "none",
        borderRadius: 0,
        fontWeight: 500,
        fontSize: 10,
        lineHeight: 1.2,
        display: "flex",
        alignItems: "center",
        gap: 4,
        cursor: "pointer",
        zIndex: 3000,
        boxShadow: "none",
        outline: "none",
        WebkitTapHighlightColor: "transparent",
        whiteSpace: "nowrap",
        appearance: "none",
      }}
    >
      <img
        src="/favicon.ico"
        alt=""
        aria-hidden="true"
        style={{
          width: 15,
          height: 15,
          objectFit: "contain",
          flexShrink: 0,
        }}
      />

      <span>Install App</span>
    </button>
  );
};

export default InstallButton;